<svg _ngcontent-ng-c3168866795="" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24"
    fill="none" stroke="#6e6b7b" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
    <path _ngcontent-ng-c3168866795="" d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
    <path _ngcontent-ng-c3168866795=""
        d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
</svg>